import { render } from "./ParticipantsContentTreeTable.vue?vue&type=template&id=12242502&scoped=true"
import script from "./ParticipantsContentTreeTable.vue?vue&type=script&lang=js"
export * from "./ParticipantsContentTreeTable.vue?vue&type=script&lang=js"

import "./ParticipantsContentTreeTable.vue?vue&type=style&index=0&id=12242502&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard_client/dashboard_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12242502"]])

export default __exports__